module.exports = __webpack_public_path__ + "static/media/la-croix-logo.47f1e355.webp";